import useDidMount from "@casino/legacy/client/hooks/lifecycle/useDidMount";
import useQueryParam from "@casino/legacy/client/hooks/router/useQueryParam";
import useToast from "@casino/legacy/client/hooks/useToast";
import AuthBrandHeading from "@casino/legacy/client/shared/AuthBrandHeading";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Stack from "@casino/legacy/client/shared/Stack";
import KeylineText from "@casino/legacyUi/KeylineText";
import BrandThemeProvider from "../../Shared/BrandThemeProvider";
import FormLogin from "./FormLogin";
import SocialLogin from "./SocialLogin";

type Props = {
  isPopover?: boolean;
  onSuccess?: () => void;
};

const LoginBody: FC<Props> = ({ onSuccess, isPopover = false }) => {
  useLogin();
  return (
    <Stack alignContent="start" gridGap="1.5rem">
      <AuthBrandHeading id="profile.login" />
      {isPopover && (
        <Stack padding="1.25rem 0">
          <p>
            <Translate id="casino.please_login_to_play_for_real" />
          </p>
        </Stack>
      )}
      <SocialLogin />
      <KeylineText>
        <Translate
          className="text-muted-foreground uppercase text-[10px] tracking-[1px]"
          id="general.or"
        />
      </KeylineText>
      <Stack space="small">
        <BrandThemeProvider hasBombayClubTheme={isPopover}>
          <FormLogin isPopover={isPopover} onSuccess={onSuccess} />
        </BrandThemeProvider>
      </Stack>
    </Stack>
  );
};

const useLogin = () => {
  const [message, , removeMsg] = useQueryParam("msg");
  const { showToast } = useToast();
  useDidMount(() => {
    if (message) {
      showToast({ message, variant: "info", timeout: 7000 });
      removeMsg();
    }
  });
};

export default LoginBody;
